import React, { useState } from "react";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
import { useEffect } from "react";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function CreateBank() {
  const navigate = useNavigate();
  const [ErrorStatusBank, setErrorStatusBank] = useState(false);
  const [loading, setLoading] = useState(false);
  const initialFValues = {
    name: "",
    is_active: "",
  };
  const StatusBank = [
    {
      id: 1,
      name: "مفعل",
      is_active: 1,
    },
    {
      id: 2,
      name: "غير مفعل",
      is_active: 0,
    },
  ];

  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "هذا الحقل  مطلوب";
    if ("is_active" in fieldValues)
      temp.is_active = fieldValues.is_active ? "" : "هذا الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
        setLoading(true);
        const bodyFormData = new FormData();
        bodyFormData.append("name", loginInput.name);
        bodyFormData.append("is_active", loginInput.is_active);

        axios
          .post(`${BaseUrl}/api/addBank`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.status == "200") {
              setLoading(false);
              sweetalert("تم إضافة بنجاح", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then((res) => {
                navigate("/Banks");
              });
            } else {
              setLoading(false);
              sweetalert(loginInput.error_list);
              setLogin({ ...loginInput, error_list: res.data.message });
            }
          });
      }
    
  };

 
  useEffect(() => {
    if(loading === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoading(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div className="main-div">
      <h3 className="titlepage">إنشاء بنك جديد</h3>

      <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label=" اسم البنك"
              name="name"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <label>حالة البنك</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="is_active"
                onChange={handleInputChange}
              >
                <option selected disabled>
                  اختر حالة البنك
                </option>
                {StatusBank.map((opts, i) => (
                  <option key={opts.id} value={opts.is_active}>
                    {opts.name}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.is_active ==''?(
            <div style={{ color: "red", fontSize: "10px" ,textAlign:'end'}}>
              {errors.is_active}
            </div>
            ):(
              <></>
            )}
      
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
        {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
          <Controls.Button
            type="submit"
            text="إضافة"
            onClick={addForm}
            variant="contained"
            className="btn-submit"
          ></Controls.Button>
          )}
        </Grid>
      </Form>
    </div>
  );
}
